import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from './base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  tokenNew = localStorage.getItem('token');
  idleState : any;
  timedOut = false;
  lastPing?: any = null;

  constructor(private router:Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService,private idle: Idle, private keepalive: Keepalive) {
    var token = localStorage.getItem('token');
    if(token == undefined || token === '' ){
      this.router.navigate(['/login']);
    }
    if(token != undefined || token != ''){
      // sets an idle timeout of 20 minutes.
      this.idle.setIdle(300);
      // sets a timeout period of 5 minutes. after 20 minutes of inactivity, the user will be considered timed out.
      this.idle.setTimeout(100);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onIdleEnd.subscribe(() => this.idleState = '');
      this.idle.onTimeout.subscribe(() => {        
        this.idleState = 'Timed out!';
        this.timedOut = true;
        localStorage.setItem('token','');
        this.router.navigate(['/login']);
        this.reset();
      });
      this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');

      this.idle.onTimeoutWarning.subscribe((countdown) =>
        this.idleState = 'You will time out in ' + countdown + ' seconds!'
      );

      // sets the ping interval to 30 seconds
      this.keepalive.interval(30);

      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

      this.reset();
    }
  }
  logout(){
    
    localStorage.setItem('token','');
    localStorage.clear();             
    sessionStorage.clear();  
    this.router.navigate(['/login']);
   // this.logout();
    }
    logoutAPI() {
     
      this.baseAPI.callLogoutApi( this.baseAPI.logoutURL).then(data => {
      
     this.spinnerService.hide();
           
    }, (err) => {
  
        
      
      });
    }

    reset(){
      this.idle.watch();
      this.timedOut = false;
     
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts